import Vue from 'vue'
import VueI18n from 'vue-i18n'

import enLocale from './en'
import zhLocale from './zh'
import koLocale from './ko'
import frLocale from './fr'
import ruLocale from './ru'
import deLocale from './de'
import esLocale from './es'
import arLocale from './ar'
import jaLocale from './ja'
import thLocale from './th'
import msLocale from './ms'
import viLocale from './vi'
import antDEnLocale from 'ant-design-vue/lib/locale-provider/en_US'
import antDZhLocale from 'ant-design-vue/lib/locale-provider/zh_CN'
import antDKoLocale from 'ant-design-vue/lib/locale-provider/ko_KR'
import antDFrLocale from 'ant-design-vue/lib/locale-provider/fr_FR'
import antDRuLocale from 'ant-design-vue/lib/locale-provider/ru_RU'
import antDDeLocale from 'ant-design-vue/lib/locale-provider/de_DE'
import antDEsLocale from 'ant-design-vue/lib/locale-provider/es_ES'
import antDArLocale from 'ant-design-vue/lib/locale-provider/ar_EG'
import antDJaLocale from 'ant-design-vue/lib/locale-provider/ja_JP'
import antDThLocale from 'ant-design-vue/lib/locale-provider/th_TH'
import antDMsLocale from 'ant-design-vue/lib/locale-provider/ms_MY'
import antDViLocale from 'ant-design-vue/lib/locale-provider/vi_VN'

Vue.use(VueI18n)
const messages = {
    // 仅保留我们自己的语言包对象，避免混入 antd 的嵌套对象
    en: enLocale,
    zh: zhLocale,
    ko: koLocale,
    fr: frLocale,
    ru: ruLocale,
    de: deLocale,
    es: esLocale,
    ar: arLocale,
    ja: jaLocale,
    th: thLocale,
    ms: msLocale,
    vi: viLocale
}

const i18n = new VueI18n({
    locale: localStorage.getItem("lang") || 'en',
    fallbackLocale: 'en',
    messages,
})
export default i18n